import styles from "./About.module.less";
import { Hero, HeroCol, HeroTitle, HeroSubtitle } from "../../components/Hero";
import { Section, SectionCol, SectionHeading, SectionParagraph } from "../../components/Section";
import jake from "../../assets/team/jake.png";
import mark from "../../assets/team/mark.png";
import nicole from "../../assets/team/nicole.png";
import anna from "../../assets/team/anna.png";
import scott from "../../assets/team/scott.png";
import julien from "../../assets/team/julien.png";
import chris from "../../assets/team/chris.png";
import aoife from "../../assets/team/aoife.png";
import { FiLinkedin, FiMapPin } from "react-icons/fi";
import Link from "next/link";
import { LocationMap } from "./components/LocationMap";
import { SecurityBadges } from "../../components/subcomponents/SecurityBadges";
import { BottomCta } from "../../components/subcomponents/BottomCta";

export const About = () => {
  const execTeam = [
    {
      name: "Jake Moore",
      role: "Chief Revenue Officer",
      img: jake,
      linkedin: "https://www.linkedin.com/in/jakeotismoore/",
    },
    {
      name: "Scott Albin",
      role: "Chief Strategy Officer",
      img: scott,
      linkedin: "https://www.linkedin.com/in/scottalbin/",
    },
    {
      name: "Chris Hyde",
      role: "Chief Information Officer",
      img: chris,
      linkedin: "https://www.linkedin.com/in/chris-hyde-6787623/",
    },
    {
      name: "Anna Bondarenko",
      role: "Chief Operating Officer",
      location: "Dubai, United Arab Emirates",
      img: anna,
      linkedin: "https://www.linkedin.com/in/annabonda/",
    },
    {
      name: "Nicole DeMaise",
      role: "Chief Legal Officer",
      img: nicole,
      linkedin: "https://www.linkedin.com/in/nicole-demaise-81a0a5191/",
    },
    {
      name: "Mark Hookey",
      role: "Founder and Chief Executive Officer",
      img: mark,
      linkedin: "https://www.linkedin.com/in/markhookey/",
    },
    {
      name: "Julien Bonnier",
      role: "VP of Product",
      img: julien,
      linkedin: "https://www.linkedin.com/in/julienbonnier/",
    },
    {
      name: "Aoife Fallon Lee",
      role: "Head of Finance",
      img: aoife,
      linkedin: "https://www.linkedin.com/in/aoife-fallon-lee-aca-ba28a737/",
    },
  ];

  const locations = [
    {
      city: "New York",
      address: "149 E 23rd Street, Suite 2035",
      address2: "New York, NY 10010",
    },
    {
      city: "Australia",
      address: "Suite 902 (Level 9), 146 Arthur Street",
      address2: "North Sydney, NSW 2060",
    },
    {
      city: "Singapore",
      address: "9 Raffles Place, #26-01, Republic Plaza",
      address2: "Singapore 048619",
    },
  ];

  return (
    <>
      <Hero background="violet-1000" withStarsAnimation>
        <HeroCol>
          <HeroTitle>Unlock the power of external data</HeroTitle>
          <HeroSubtitle>
            Demyst believes that external data is the next frontier of business impact, yet it is
            often locked away. Organizations want to harness more value from the extensive external
            data ecosystem and meet their data governance goals. Demyst supports enterprise external
            data management with a market leading product and managed service to empower your
            central data teams, and analytics and business stakeholders across the enterprise.
          </HeroSubtitle>
        </HeroCol>
      </Hero>

      <Section
        background="blue-25"
        masthead={{
          title: "Our history and future",
          subtitle: [
            "We started in 2010 upon realizing that, while the world is supposedly awash with data, \
            very little of it is being used for customer benefit. 80% of analytics projects failed \
            at the ideation, discovery, or deployment phase, with true business impact rarely \
            realized despite the clear possibilities.",
            "We have evolved a technology platform that underpins our service, enabling us to \
            partner closely with the most innovative organizations to collaboratively take on the \
            most detailed aspects of their data projects. Over 100 of the most exacting banks and \
            insurers have discovered and deploy the world's best external data through Demyst for \
            any and all of their use cases including KYC, credit, risk, marketing and more.",
          ],
        }}
      />

      <Section background="white" type="one-col" masthead={{ title: "The Demyst Executive Team" }}>
        <SectionCol>
          <div className={styles.Team}>
            {execTeam.map(p => (
              <div className={styles.Exec} key={p.name}>
                <div className={styles.Image}>
                  <img src={p.img.src} alt={p.name} width="356" height="420" layout="responsive" />
                </div>
                <SectionHeading className={styles.Name} type="h3">
                  {p.name}
                </SectionHeading>
                <SectionHeading className={styles.Role} asParagraph type="h4">
                  {p.role}
                </SectionHeading>
                <Link
                  href={p.linkedin}
                  isExternal
                  className={styles.Linkedin}
                  title="View Linkedin Account"
                >
                  <FiLinkedin alt="Linkedin Icon" />
                </Link>
              </div>
            ))}
          </div>
        </SectionCol>
      </Section>

      <Section
        background="violet-900"
        type="one-col"
        masthead={{
          title: "Our market",
          subtitle: [
            "Current geography list: Australia, Austria, Brazil, Canada, India, Pakistan, Philippines, Singapore, South Africa, Ukraine, United Arab Emirates, United States.",
          ],
        }}
        removeBottomPadding
      >
        <SectionCol>
          <div className={styles.Earth}>
            <LocationMap />
          </div>
        </SectionCol>
      </Section>

      <Section background="violet-900" type="three-col" masthead={{ title: "Our offices" }}>
        {locations.map(l => (
          <SectionCol key={l.city}>
            <div className={styles.Location}>
              <FiMapPin />
              <SectionHeading>{l.city}</SectionHeading>
              <SectionParagraph>
                {l.address}
                <br />
                {l.address2}
              </SectionParagraph>
            </div>
          </SectionCol>
        ))}
      </Section>

      <Section background="blue-800" type="one-col">
        <SectionCol>
          <BottomCta />
        </SectionCol>
      </Section>

      <Section background="blue-1000" removeBottomPadding removeTopPadding>
        <SectionCol>
          <SecurityBadges />
        </SectionCol>
      </Section>
    </>
  );
};
